export const countryMapping = () => {
  const country = [
    // Vietnam
    {
      code: 'vn',
      name: 'Vietnam',
      primaryLanguage: 'Vietnamese',
      secondaryLanguage: 'English',
      locale: 'vi-vn',
      BASE_URL: {
        dev: 'https://dev.api.vn.academy-preprod.amway.com/mw',
        qa: 'https://qa.api.vn.academy-preprod.amway.com/mw',
        prod: 'https://api.academy.amway.com.vn/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.vn.academy-preprod.amway.com/dashboard',
        qa: 'https://qa.admin.vn.academy-preprod.amway.com/dashboard',
        prod: 'https://admin.academy.amway.com.vn/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa1uaupq9szMx9bs0h8',
        qa: '0oa1ur7k15rc3ozAg0h8',
        prod: '0oa1vycrc3kqTdEdf0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "893a36d4-6710-466b-910e-77b6ca70eb7a",
          qa: "d3ee3734-25cd-4366-a558-a1554e63c2e3",
          prod: "adad3b63-8b5d-4770-8c20-b811164978e1",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.vn.academy-preprod.amway.com',
        'https://qa.admin.vn.academy-preprod.amway.com',
        'https://admin.academy.amway.com.vn',
      ],
    },

    // North America
    {
      code: 'ana',
      name: 'North America',
      primaryLanguage: 'English',
      secondaryLanguage: 'English',
      locale: 'en-us',
      BASE_URL: {
        dev: 'https://dev.api.ana.academy-preprod.amway.com/mw',
        qa: 'https://qa.api.ana.academy-preprod.amway.com/mw',
        prod: ' https://api.academy.amway.com/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.ana.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.ana.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.ana.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.ana.academy-preprod.amway.com/dashboard',
        qa: 'https://qa.admin.ana.academy-preprod.amway.com/dashboard',
        prod: 'https://admin.academy.amway.com/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa1u4wugdeQJUkQs0h8',
        qa: '0oa1ur8pqpdZlek4m0h8',
        prod: '0oa1wghvi0le72s0m0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "dc9b1c5c-24a1-4498-9144-fa2acb938876",
          qa: "ee420a98-23ff-4037-851e-076cc1b6c7cf",
          prod: "392fb7a8-bef9-4b72-9683-f1501a96441f",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.ana.academy-preprod.amway.com',
        'https://qa.admin.ana.academy-preprod.amway.com',
        'https://admin.academy.amway.com',
      ],
    },

    // India
    {
      code: 'in',
      name: 'India',
      primaryLanguage: 'English',
      secondaryLanguage: 'English',
      locale: 'en-in',
      BASE_URL: {
        dev: 'https://dev.api.in.academy-preprod.amway.com/mw',
        qa: 'https://qa.api.in.academy-preprod.amway.com/mw',
        prod: 'https://api.academy.amway.in/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.in.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.in.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.in.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.in.academy-preprod.amway.com/dashboard',
        qa: 'https://qa.admin.in.academy-preprod.amway.com/dashboard',
        prod: 'https://admin.academy.amway.in/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa1p8u8aqtR2Ske80h8',
        qa: '0oa1rpysehw1IDIxr0h8',
        prod: '0oa1rvcfyu8Tf03sz0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "83eabc57-3498-4faf-921c-1abda87a3c85",
          qa: "b6e4300e-4645-45da-b1ae-c0a3b4f4df01",
          prod: "d4d73fbb-b23b-4f08-9dbb-99eec1b3c041",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.in.academy-preprod.amway.com',
        'https://qa.admin.in.academy-preprod.amway.com',
        'https://admin.academy.amway.in',
      ],
    },

    // Taiwan
    {
      code: 'tw',
      name: 'TW',
      primaryLanguage: 'English',
      secondaryLanguage: 'English',
      locale: 'zh-tw',
      is_segmented: true,
      segmentAutoAssign: true,  
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.co.kr/mw',
        qa: 'https://qa.api.academy-preprod.amway.co.kr/mw',
        prod: 'https://api.amwayacademy.amway.co.kr/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.com.tw/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.com.tw/dashboard',
        prod: 'https://admin.academy.amway.com.tw/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa23dre5dffLJRws0h8',
        qa: '0oa23drgbzeYHDR7q0h8',
        prod: '0oa24dmpkfy3O0idD0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "959696bb-51b8-485e-b6a8-a0f6e13c6292",
          qa: "05834a16-de37-4ab9-82ac-c224562f927f",
          prod: "7eaded45-0f38-4042-92f8-092eaa6b66c2",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.com.tw',
        'https://qa.admin.academy-preprod.amway.com.tw',
        'https://admin.academy.amway.com.tw',
      ],
    },
    // Latam
    {
      code: 'es',
      name: 'LATAM',
      primaryLanguage: 'Spanish',
      secondaryLanguage: 'Portuguese',
      locale: 'es-419',
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.com.mx/mw',
        qa: 'https://qa.api.academy-preprod.amway.com.mx/mw',
        prod: 'https://api.academy.amway.com.mx/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.ana.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.ana.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.ana.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.com.mx/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.com.mx/dashboard',
        prod: 'https://admin.academy.amway.com.mx/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa1xtwe39uxWqEHH0h8',
        qa: '0oa1y37w1w7RMwhx80h8',
        prod: '0oa1yuy2vfsVHsPYI0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "66dfc42b-172d-4862-a74a-260ab29d2ea2",
          qa: "db0aefe4-8f2b-41d1-a792-809f692a6d46",
          prod: "6465529e-8c82-4cde-ac40-7ec02922c279",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.com.mx',
        'https://qa.admin.academy-preprod.amway.com.mx',
        'https://admin.academy.amway.com.mx',
      ],
    },
    //ESAN
    {
      code: 'en',
      name: 'ESAN',
      primaryLanguage: 'English',
      secondaryLanguage: 'English',
      locale: 'en-us',
      BASE_URL: {
        dev: 'https://dev.api.esan.academy-preprod.amway.com/mw',
        qa: 'https://qa.api.esan.academy-preprod.amway.com/mw',
        prod: 'https://api.academy.amway.it/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.it.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.it.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.it.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.esan.academy-preprod.amway.com/dashboard',
        qa: 'https://qa.admin.esan.academy-preprod.amway.com/dashboard',
        prod: 'https://admin.academy.amway.it/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa1yg6d898HQKTEN0h8',
        qa: '0oa1yg68x1pKqGZcj0h8',
        prod: '0oa1z28n32skXSqVG0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "8dcb49b3-6360-40d7-a5e6-a97907768419",
          qa: "e89ae3b4-4e68-47aa-9ae4-aa3a4a1981c5",
          prod: "e3b7070a-d111-4272-b54e-8904f38e4eb4",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.esan.academy-preprod.amway.com',
        'https://qa.admin.esan.academy-preprod.amway.com',
        'https://admin.academy.amway.it',
      ],
    },
    //JAPAN Configs
    {
      code: 'jp',
      name: 'JAPAN',
      primaryLanguage: 'Japanese',
      secondaryLanguage: 'English',
      locale: 'ja-jp',
      BASE_URL: {
        dev: ' https://dev.api.academy-preprod.amwaylive.com/mw',
        qa: ' https://qa.api.academy-preprod.amwaylive.com/mw',
        prod: 'https://api.academy.amwaylive.com/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amwaylive.com/dashboard',
        qa: 'https://qa.admin.academy-preprod.amwaylive.com/dashboard',
        prod: 'https://admin.academy.amwaylive.com/dashboard',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "601fdff3-4b52-4a02-9459-c67c7e26e68b",
          qa: "3264edec-e738-484a-9610-2171363e4919",
          prod: "5a66849e-ece8-4970-b54a-ef9990aac143",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      CLIENT_ID: {
        dev: '0oa1z28odvnqRa7wH0h8',
        qa: '0oa1z72crhhZBB7BR0h8',
        prod: '0oa1zlpf78hFDCU0m0h8',
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amwaylive.com',
        'https://qa.admin.academy-preprod.amwaylive.com',
        'https://admin.academy.amwaylive.com',
      ],
    },
    //Thailand Configs
    {
      code: 'th',
      name: 'THAILAND',
      primaryLanguage: 'Thai',
      secondaryLanguage: 'English',
      locale: 'th-th',
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.co.th/mw',
        qa: 'https://qa.api.academy-preprod.amway.co.th/mw',
        prod: 'https://api.academy.amway.co.th/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.co.th/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.co.th/dashboard',
        prod: 'https://admin.academy.amway.co.th/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa20i2q2u5LjyEJ70h8',
        qa: '0oa20zv45f685aKKD0h8',
        prod: '0oa21gsjrboEs1zaT0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "56aaf437-326e-4ab1-8e4e-ad3d7f41499a",
          qa: "2ce5c57b-5d40-4677-82d1-4fe8016aadbe",
          prod: "85a79906-36d0-45d9-ab41-4644afb94491",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.co.th',
        'https://qa.admin.academy-preprod.amway.co.th',
        'https://admin.academy.amway.co.th',
      ],
    },
    //MSB Configs
    {
      code: 'msb',
      name: 'MSB',
      is_segmented: true,
      primaryLanguage: 'English',
      secondaryLanguage: 'English',
      locale: 'en-us',
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.my/mw',
        qa: 'https://qa.api.academy-preprod.amway.my/mw',
        prod: 'https://api.academy.amway.my/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.my/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.my/dashboard',
        prod: 'https://admin.academy.amway.my/dashboard',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "86c668b5-032f-4f59-81b8-ca57f1aabc34",
          qa: "80462e43-8a4f-4751-bbc5-64514eac9277",
          prod: "e6cc2bb2-392e-4282-9c53-0a27b5a3321e",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      CLIENT_ID: {
        dev: '0oa21jv2vnpFuJxt10h8',
        qa: '0oa21jvjonx1QHJKr0h8',
        prod: '0oa21pj549psFsKWU0h8',
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.my',
        'https://qa.admin.academy-preprod.amway.my',
        'https://admin.academy.amway.my',
      ],
    },
    //Korea Configs
    {
      code: 'kr',
      name: 'KR',
      primaryLanguage: 'Korean',
      is_segmented: true,
      segmentAutoAssign: true,
      locale: 'ko-kr',
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.co.kr/mw',
        qa: 'https://qa.api.academy-preprod.amway.co.kr/mw',
        prod: 'https://api.amwayacademy.amway.co.kr/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.co.kr/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.co.kr/dashboard',
        prod: 'https://admin.amwayacademy.amway.co.kr/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa23dre5dffLJRws0h8',
        qa: '0oa23drgbzeYHDR7q0h8',
        prod: '0oa24dmpkfy3O0idD0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "61589570-fb0c-42e4-9d88-c89f21f5fed2",
          qa: "88e8229d-2b25-4549-b2e3-01e1d76412a1",
          prod: "45c42e5a-5ae4-4366-a420-a6b222996365",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.co.kr',
        'https://qa.admin.academy-preprod.amway.co.kr',
        'https://admin.amwayacademy.amway.co.kr'
      ],
    },
    {
      code: 'hk',
      name: 'HK',
      primaryLanguage: 'Chinese Tradational',
      is_segmented: true,
      segmentAutoAssign: true,
      locale: 'zh-hk',
      BASE_URL: {
        dev: 'https://dev.api.academy-preprod.amway.co.kr/mw',
        qa: 'https://qa.api.academy-preprod.amway.co.kr/mw',
        prod: 'https://api.amwayacademy.amway.co.kr/mw',
      },
      BASE_CUSTOM_UG_URL: {
        dev: 'https://services-test.tw.creators.amwayglobal.com/groups/v1',
        qa: 'https://services-stage.tw.creators.amwayglobal.com/groups/v1',
        prod: 'https://services.tw.creators.amwayglobal.com/groups/v1',
      },
      REDIRECT_URI: {
        dev: 'https://dev.admin.academy-preprod.amway.com.hk/dashboard',
        qa: 'https://qa.admin.academy-preprod.amway.com.hk/dashboard',
        prod: 'https://admin.academy.amway.com.hk/dashboard',
      },
      CLIENT_ID: {
        dev: '0oa23dre5dffLJRws0h8',
        qa: '0oa23drgbzeYHDR7q0h8',
        prod: '0oa24dmpkfy3O0idD0h8',
      },
      ENTRA: {
        CLIENT_ID: {
          dev: "e9335e08-6d0a-4bc3-9c7a-3d839405a5b8",
          qa: "f54b1ab0-31e0-496d-a62a-bf5ccc4cd4aa",
          prod: "564a4c16-14b5-4d58-bce8-c1b6f0240267",
        },
        AUTHORITY: {
          dev: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          qa: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize",
          prod: "https://login.microsoftonline.com/38c3fde4-197b-47b9-9500-769f547df698/oauth2/v2.0/authorize"
        } ,
      },
      OIDC_ISSUER: 'https://amway.okta.com/oauth2/aus1h78lyb8aJ7EBp0h8',
      urls: [
        'https://dev.admin.academy-preprod.amway.com.hk',
        'https://qa.admin.academy-preprod.amway.com.hk',
        'https://admin.academy.amway.com.hk',
      ],
    },
  ];

  return country;
};
